import React, { useState } from "react";
import { basicValidation } from "../../amorg-common";
import { Button } from "../button/Button";
import { ButtonVariant, ButtonSize } from "../button/Shared";
import { iconName } from "../icons/Icons";
import { TooltipTheOneWrapper } from "../TooltipTheOne";



type CopyButtonProps =
{
    value: string,
    variant?:ButtonVariant,
    text?: string,
    icon?:iconName,
    toolTipContent?: React.ReactNode,
    size?: ButtonSize,
    disabled?:boolean
};

export function CopyButton(props: CopyButtonProps): JSX.Element {

    const [showToolTip, setShowToolTip] = useState(false)

    function handleClickCopy() {
        navigator.clipboard.writeText(props.value);
        setShowToolTip(true)
        setTimeout(() => {
            setShowToolTip(false)
        }, 2000);
    }

    const innerDisabled = props.disabled || !basicValidation.isValidUrl(props.value, false, 2000);

    let regularToolip = props.toolTipContent !== undefined ? props.toolTipContent : "Kopiér link";
    if(innerDisabled)
        regularToolip = '';

    return (
        <TooltipTheOneWrapper tooltipContent={showToolTip ? "Linket er kopieret" : regularToolip}>
            <Button variant={props.variant ?? "text"}
                text={props.text}
                onClick={handleClickCopy} 
                icon={props.icon ?? "interface_actions_copy"} 
                toolTipText={showToolTip ? "Linket er kopieret" : undefined} 
                disabled={innerDisabled}
                size={props.size ?? "32px"}
            />
        </TooltipTheOneWrapper>
    )
}